import React, { Component } from 'react';
import classNames from 'classnames';

import './Annotation.scss';

export default class Annotation extends Component {

    render() {
        const className = classNames({
            "Annotation__container": true,
            [`Annotation__container--${this.props.position}`]:  true
        });

        return (
            <div className="Annotation">
                <div className={className}>
                    <span className="Annotation__icon">!</span><div className="Annotation__title">{this.props.title}</div>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/Annotation/index.js